import React, { useRef } from 'react';
import style from './NumberInputWithUnit.module.css';
import PropTypes from 'prop-types';
import { colors } from '../../../../colorVars';

const NumberInputWithUnit = ({
  direction,
  children,
  type,
  value,
  setValue,
  margin,
  disabled,
  onBlur,
  inputWidth,
  backgroundColor,
  color,
}) => {
  const inputRef = useRef(null);
  const spanBackgroundColor =
    children === '$'
      ? colors.green
      : children === '%'
      ? colors.orange
      : colors.blue;
  if (direction === 'left') {
    return (
      <div style={{ margin, color }} className={style.div}>
        <span
          style={{
            marginRight: '-1px',
            borderRadius: '3px 0 0 3px',
            backgroundColor: spanBackgroundColor,
            color: colors.lightGrey,
          }}
          className={style.span}
        >
          {children}
        </span>
        <input
          ref={inputRef}
          onClick={() => inputRef.current.focus()}
          disabled={disabled}
          style={{
            borderRadius: '0 3px 3px 0',
            width: inputWidth,
            backgroundColor,
            color,
          }}
          className={style.input}
          type={type}
          value={value}
          onChange={({ target }) => setValue(target.value)}
          onBlur={({ target }) => onBlur(target.value)}
        />
      </div>
    );
  } else {
    return (
      <div style={{ margin, color }} className={style.div}>
        <input
          ref={inputRef}
          onClick={() => inputRef.current.focus()}
          disabled={disabled}
          style={{
            borderRadius: '3px 0 0 3px',
            width: inputWidth,
            backgroundColor,
            color,
          }}
          className={style.input}
          type={type}
          value={value}
          onChange={({ target }) => setValue(target.value)}
          onBlur={({ target }) => onBlur(target.value)}
        />
        <span
          style={{
            marginLeft: '-1px',
            borderRadius: ' 0 3px 3px 0',
            backgroundColor: spanBackgroundColor,
            color: colors.lightGrey,
          }}
          className={style.span}
        >
          {children}
        </span>
      </div>
    );
  }
};
NumberInputWithUnit.defaultProps = {
  disabled: false,
  onblur: () => {},
  inputWidth: '3.5em',
  type: 'number',
};
NumberInputWithUnit.propTypes = {
  backgroundColor: PropTypes.any,
  children: PropTypes.string.isRequired,
  color: PropTypes.any,
  direction: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  inputWidth: PropTypes.string,
  margin: PropTypes.string,
  onBlur: PropTypes.func,
  onblur: PropTypes.func,
  setValue: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
};
export default NumberInputWithUnit;
